import { MapContainer, TileLayer, Marker } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import { buildAvatarIcon, buildClusterIcon, buildMeIcon, Recenter } from "./mapIcons";

/**
 * Dark-tile Leaflet map with your-position marker + clustered avatar pins.
 * All map-only concerns live here so filter/sheet/preview components stay
 * DOM-only and easy to tweak.
 */
export default function NearbyMap({ coords, filtered, onSelect }) {
  return (
    <>
      <style>{`
        @keyframes pandax-pin-pulse {
          0%   { box-shadow: 0 0 0 3px #f43f5e, 0 0 8px rgba(244,63,94,0.7); }
          50%  { box-shadow: 0 0 0 6px rgba(244,63,94,0.35), 0 0 24px rgba(244,63,94,0.75); }
          100% { box-shadow: 0 0 0 3px #f43f5e, 0 0 8px rgba(244,63,94,0.7); }
        }
        @keyframes pandax-me-pulse {
          0%   { transform: scale(0.8); opacity: 0.8; }
          100% { transform: scale(1.8); opacity: 0; }
        }
        .leaflet-container { background: #0a0a0a; }
        .leaflet-container .leaflet-control-attribution {
          background: rgba(0,0,0,0.55); color: #a1a1aa;
        }
        .leaflet-container .leaflet-control-attribution a { color: #f43f5e; }
        .pandax-cluster { background: transparent !important; border: none !important; }
        .pandax-avatar-marker { background: transparent !important; border: none !important; }
      `}</style>

      <MapContainer
        center={[coords.lat, coords.lng]}
        zoom={11}
        style={{ height: "100vh", width: "100%" }}
        zoomControl={false}
        data-testid="nearby-map"
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>'
          url={process.env.REACT_APP_CARTO_BASEMAP_KEY
            ? `https://{s}.basemaps.cartocdn.com/rastertiles/dark_all/{z}/{x}/{y}{r}.png?key=${process.env.REACT_APP_CARTO_BASEMAP_KEY}`
            : "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"}
          subdomains={["a", "b", "c", "d"]}
        />
        <Recenter coords={coords} zoom={11} />
        <Marker position={[coords.lat, coords.lng]} icon={buildMeIcon()} />
        <MarkerClusterGroup
          chunkedLoading
          showCoverageOnHover={false}
          spiderfyOnMaxZoom
          maxClusterRadius={45}
          iconCreateFunction={buildClusterIcon}
        >
          {filtered.filter((p) => p.lat != null && p.lng != null).map((p) => (
            <Marker
              key={p.id}
              position={[p.lat, p.lng]}
              icon={buildAvatarIcon(p)}
              eventHandlers={{ click: () => onSelect(p) }}
            />
          ))}
        </MarkerClusterGroup>
      </MapContainer>
    </>
  );
}
